var React = require('react');

function CategoryFashion (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M13.5,13.6H2.5c-0.4,0-0.8-0.3-0.9-0.7L0,5c-0.1-0.4,0.1-0.7,0.4-0.9c0.3-0.2,0.7-0.2,1,0.1l3.2,2.6l2.6-4\n\tc0.3-0.5,1.1-0.5,1.5,0l2.6,4l3.2-2.6c0.3-0.2,0.7-0.3,1-0.1C15.9,4.3,16.1,4.6,16,5l-1.6,7.9C14.3,13.3,14,13.6,13.5,13.6z\n\t M3.2,11.9h9.7l1-4.9l-2.1,1.7c-0.2,0.2-0.4,0.2-0.7,0.2c-0.2,0-0.5-0.2-0.6-0.4L8,4.8L5.6,8.5C5.4,8.7,5.2,8.8,5,8.8\n\tc-0.2,0-0.5,0-0.7-0.2L2.2,7L3.2,11.9z"}));
}

CategoryFashion.defaultProps = {"version":"1.1","id":"fashion","x":"0px","y":"0px","viewBox":"0 0 16 16","style":{"enableBackground":"new 0 0 16 16"},"xmlSpace":"preserve"};

module.exports = CategoryFashion;

CategoryFashion.default = CategoryFashion;
